<script setup lang="ts">
import { SIDEBAR_IDS } from '@design-system/data/sidebarIds'
import type { PdpEcommerceBlockInfoAndDetailsSideSlideProps } from './PdpEcommerceBlockInfoAndDetailsSideSlide.props'

const { productDetails } =
  defineProps<PdpEcommerceBlockInfoAndDetailsSideSlideProps>()

const { ts } = useI18n()

const formatComposition = (composition: string) => {
  if (!composition) return ''

  return composition
    .split(';')
    .map(part => part.trim())
    .filter(part => part.length > 0)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join('<br>')
}
</script>

<template>
  <OrganismsSidebarSlide
    :id="SIDEBAR_IDS.pdpEcommerceblockProductInfoAndDetailsSideSlide"
    :header-props="{
      titleText: $ts('pdp.productDetails.infoAndDetails'),
    }"
  >
    <template #body>
      <div class="gap-lg lg:gap-xl flex flex-col pb-12">
        <!-- DESCRIPTION -->
        <div class="gap-xxs flex flex-col items-start">
          <h3 class="text-medium-6">
            {{
              $ts('pdp.productDetails.informationSection.productDescription')
            }}
          </h3>
          <UtilsInfo
            :max-character="300"
            :content="productDetails.editoralDescription"
            :expanded-label="
              ts('pdp.productDetails.informationSection.readMore')
            "
            :reduced-label="
              ts('pdp.productDetails.informationSection.readLess')
            "
          />
        </div>
        <!-- COMPOSITION PRODUCT -->
        <div v-if="productDetails?.composition" class="gap-xxs flex flex-col">
          <h3 class="text-medium-6">
            {{
              $ts('pdp.productDetails.informationSection.productComposition')
            }}
          </h3>
          <div
            class="text-light-6"
            v-html="formatComposition(productDetails?.composition)"
          ></div>
        </div>
        <!-- TECHNICAL DETAILS -->
        <div class="gap-xxs flex flex-col">
          <h3 class="text-medium-6">
            {{ $ts('pdp.productDetails.informationSection.productDetails') }}
          </h3>
          <ul
            v-for="techInfo in productDetails.technicalDetails"
            :key="techInfo"
          >
            <li class="text-light-6">
              <UtilsMarkdown :content="techInfo" />
            </li>
          </ul>
        </div>
        <!-- PRODUCT CODE -->
        <div class="gap-xxs flex flex-col">
          <h3 class="text-medium-6">
            {{ $ts('pdp.productDetails.informationSection.productCode') }}
          </h3>
          <div class="text-light-6">
            {{ productDetails.SkuCode }}
          </div>
        </div>
        <!-- PRODUCT FIT -->
        <!-- <div
          v-if="!!productDetails.fitDescription"
          class="gap-xxs flex flex-col"
        >
          <div class="text-medium-6">
            {{ $ts('pdp.productDetails.informationSection.productFit') }}
          </div>
          <div class="text-light-6">
            {{ productDetails.fitDescription }}
          </div>
        </div> -->
      </div>
    </template>
  </OrganismsSidebarSlide>
</template>
